import React, { useState } from 'react';
import { useLazyWorkplaceRolesQuery } from '../../../../../graphql/graphql';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import { useEffectAsync } from '../../../../../helpers';
import MultiSelectWithCheckList from '../MultiSelectWithCheckList/MultiSelectWithCheckList';
import { MenuPlacement } from '../../../Enums/MenuPlacement.enum';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
	portal?: boolean;
	excludeRoleKeys?: string[];
	includeRoleKeys?: string[];
	menuPlacement?: MenuPlacement;
}

const RoleMultiSelectWithCheckList: React.FC<Props> = props => {
	const {
		value,
		onChange,
		portal,
		excludeRoleKeys,
		includeRoleKeys,
		menuPlacement,
	} = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);
	const [isReady, setIsReady] = useState(false);
	const [options, setOptions] = useState<SelectValue[]>();
	const [getWorkplaceRoles] = useLazyWorkplaceRolesQuery();

	useEffectAsync(async () => {
		setIsReady(isReady);
		const items: SelectValue[] = [];

		const { workplaceAclRoles } = await getWorkplaceRoles().unwrap();

		for (const workplaceRole of workplaceAclRoles?.data || []) {
			if (!excludeRoleKeys?.some(item => item === workplaceRole?.key)) {
				if (includeRoleKeys && includeRoleKeys?.length > 0) {
					if (includeRoleKeys?.some(item => item === workplaceRole?.key)) {
						items.push({
							value: workplaceRole?.id,
							label: workplaceRole?.name || '',
						});
					}
				} else {
					items.push({
						value: workplaceRole?.id,
						label: workplaceRole?.name || '',
					});
				}
			}
		}

		setOptions(items);
		setIsReady(true);
	}, []);

	if (isReady) {
		return (
			<MultiSelectWithCheckList
				{...props}
				options={options}
				onChange={onChange}
				value={defaultValue?.label ? defaultValue : value}
				portal={portal}
				menuPlacement={menuPlacement}
			/>
		);
	}

	return null;
};

export default RoleMultiSelectWithCheckList;
